import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Fragment, memo, useMemo } from 'react';
import { isMediumUI } from 'shared/app/lib/choose-ui-type';
import { MediumUISortablePanels } from './medium';
import { SmallUISortablePanels } from './small';
import { useDeviceUISettings } from 'console/shared/contexts/device-ui-settings';
import { useDesignPackage } from 'console/shared/hooks/helpers';
import { useDeviceConfig } from 'console/shared/contexts/device/config';
export const SortablePanels = memo(function SortablePanels(props) {
    const { list } = props;
    const { is_vehicle_device } = useDeviceConfig();
    const { simple_view_mode } = useDeviceUISettings();
    const allow_design_package = useDesignPackage();
    const Component = isMediumUI() && allow_design_package && !is_vehicle_device
        ? MediumUISortablePanels
        : SmallUISortablePanels;
    const panels = useMemo(() => list.map(({ id, component }) => _jsx(Fragment, { children: component }, id)), [list]);
    if (simple_view_mode) {
        return _jsx(_Fragment, { children: panels });
    }
    return _jsx(Component, { ...props });
});
